module.exports = __webpack_public_path__ + "img/location-crosshairs-slash.710666aa.svg";